import {
  DateRangePickerField,
  Form,
  SubmitButton,
  TextInputField,
} from '@/components';
import { useForm } from '@/hooks';
import { zodResolver } from '@hookform/resolvers/zod';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { z } from 'zod';
import { MinistryFormSchema } from '../../models';

type FormValues = z.infer<typeof MinistryFormSchema>;

type Props = {
  initialValues?: Partial<FormValues>;
  onSubmit: (values: FormValues) => void;
};

export const MinistryForm: FC<Props> = ({ initialValues, onSubmit }) => {
  const { t } = useTranslation();
  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting, isDirty, isSubmitSuccessful },
  } = useForm<FormValues>({
    defaultValues: initialValues,
    resolver: zodResolver(MinistryFormSchema),
  });

  return (
    <Form
      leavePageAlertCondition={{
        isDirty,
        isSubmitting,
        isSubmitSuccessful,
      }}
      layout="vertical"
      onFinish={handleSubmit(onSubmit)}
    >
      <TextInputField
        name="code"
        autocompleteKey="ministry.code"
        label={t('code')}
        control={control}
        errors={errors}
        required
      />

      <TextInputField
        name="name"
        autocompleteKey="ministry.name"
        label={t('name')}
        control={control}
        errors={errors}
        required
      />

      <DateRangePickerField
        name="period"
        control={control}
        errors={errors}
        label={t('ministry.period')}
      />

      <SubmitButton loading={isSubmitting} disabled={!isDirty} />
    </Form>
  );
};
